import React from "react";
// Install HMR/WebSocket guard in production to suppress dev-server WS attempts
import "./utils/hmrGuard";

import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
